














import { Component, Vue, Prop } from 'vue-property-decorator'
import smallCouponItem from './smallCouponItem.vue'
import bigCouponItem from './bigCouponItem.vue'

@Component({
  components: {
    smallCouponItem,
    bigCouponItem
  }
})
export default class CouponList extends Vue {
  @Prop({ default: () => [] }) readonly couponlist!: any
}
